import { Box, Button, TextField } from '@mui/material';
import { useToast } from '@shared/components/ui/use-toast';
import sentry from '@shared/services/sentry';
import React, { useState } from 'react';
import { useChangePassword } from '../api';

interface ChangePasswordFormProps {
  children?: React.ReactNode;
  HandlePasswordChangeForm: () => void;
}

const ChangePasswordForm: React.FC<ChangePasswordFormProps> = () => {
  const { mutateAsync: changePassword } = useChangePassword();
  const { toast } = useToast();

  const initialFormData = Object.freeze({
    new_password1: '',
    new_password2: '',
  });

  const [formData, updateFormData] = useState(initialFormData);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateFormData({
      ...formData,
      [e.target.name]: e.target.value.trim(),
    });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      await changePassword({
        data: {
          new_password1: formData.new_password1,
          new_password2: formData.new_password2,
        },
      });

      toast({
        title: 'Password changed successfully',
        variant: 'success',
      });

      updateFormData({
        ...formData,
        new_password1: '',
        new_password2: '',
      });
    } catch (err) {
      sentry.log(err);
      if (err.response.status === 400) {
        toast({
          title:
            'Invalid details. Please enter the correct password and ensure the new passwords match',
          variant: 'destructive',
        });
      } else {
        toast({
          title: 'There is a problem with our server. Please try again later',
          variant: 'destructive',
        });
      }
      updateFormData({
        ...formData,
        new_password1: '',
        new_password2: '',
      });
    }
  };
  return (
    <>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          width: '100%',
        }}
      >
        <TextField
          id="new_password1"
          name="new_password1"
          label="New Password"
          type="password"
          fullWidth={true}
          margin="normal"
          onChange={handleChange}
          value={formData.new_password1}
        />
        <TextField
          id="new_password2"
          name="new_password2"
          label="New Password (again)"
          type="password"
          fullWidth={true}
          margin="normal"
          onChange={handleChange}
          value={formData.new_password2}
        />
        <Button
          type="submit"
          variant="contained"
          sx={{
            marginTop: '1rem',
          }}
        >
          Change Password
        </Button>
      </Box>
    </>
  );
};

export default ChangePasswordForm;
